import React from 'react';
export const NAVIGATE_EVENT = `sail:navigate`;
// default useNavigate context hook
function useDefaultNavigate() {
    const navigateHandler = (_href, e)=>{
        const navigateEvent = new CustomEvent(NAVIGATE_EVENT, {
            bubbles: true,
            cancelable: true
        });
        if (!e.target.dispatchEvent(navigateEvent)) {
            return false;
        }
    };
    return navigateHandler;
}
// default useHrefAdapter context hook
function useDefaultHrefAdapter() {
    const defaultHrefAdapter = (href)=>{
        if (typeof href === 'undefined') {
            return undefined;
        }
        if (typeof href !== 'string') {
            throw new Error('Invalid href value, please provide a correct hrefAdapter through the Unstable_ActionHrefAdapterContext');
        }
        return href;
    };
    return defaultHrefAdapter;
}
export const Unstable_ActionHrefAdapterContext = React.createContext(useDefaultHrefAdapter);
export const Unstable_ActionNavigateContext = React.createContext(useDefaultNavigate);

//# sourceMappingURL=context.js.map